import {
    CO_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING,
    CO_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING_SUCCESS,
    CO_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING_FAILED,
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    environmentalAndHealthCertification: null,
  }
  
  const coEnvironmentalAndHealthCertification = (state = initialState, action) => {
    switch (action.type) {
      case CO_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING:
        state = {
          ...state,
          loading: true,
          environmentalAndHealthCertification: action.payload,
        }
        break
      case CO_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING_SUCCESS:
        state = { ...state, loading: false, environmentalAndHealthCertification: action.payload }
        break
      case CO_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING_FAILED:
        state = { ...state, loading: false }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default coEnvironmentalAndHealthCertification
  